import { ref, toRef, unref } from 'vue';

export const useAmsOsramForm = props => {
    const osramTypes = ['LED', 'laser', 'Photodetectors'];
    const amsTypes = ['Sensors', 'Interfaces'];

    const formTopic = ref(null);
    const formTitle = ref(props.formTitle);
    const trackingTitle = toRef(props, 'trackingTitle');
    const urlValue = toRef(props,'urlValue');
    const attachURL = toRef(props, 'attachValue');

    const handleDataLayerFormTracking = payload => {
        if (!window.dataLayer) {
            return;
        }

        // NW-1905
        if(urlValue.value.includes('web2case')){
            if(attachURL.value !== ''){
                payload['attachmentURL'] = attachURL.value;
            }
            if(window.localStorage.getItem('gaconnector_all_traffic_sources') !== '' ){
                payload['GA_all_traffic_sources__c'] = window.localStorage.getItem('gaconnector_all_traffic_sources');
            }
            else {
                payload['GA_all_traffic_sources__c'] = getCookie('gaconnector_all_traffic_sources');
            }

            if(window.localStorage.getItem('gaconnector_browser') !== '' ){
                payload['GA_browser__c'] = window.localStorage.getItem('gaconnector_browser');
            }
            else {
                payload['GA_browser__c'] = getCookie('gaconnector_browser');
            }

            if(window.localStorage.getItem('gaconnector_city') !== '' ){
                payload['GA_city__c'] = window.localStorage.getItem('gaconnector_city');
            }
            else {
                payload['GA_city__c'] = getCookie('gaconnector_city');
            }

            if(window.localStorage.getItem('gaconnector_country') !== '' ){
                payload['GA_country__c'] = window.localStorage.getItem('gaconnector_country');
            }
            else {
                payload['GA_country__c'] = getCookie('gaconnector_country');
            }

            if(window.localStorage.getItem('gaconnector_device') !== '' ){
                payload['GA_device__c'] = window.localStorage.getItem('gaconnector_device');
            }
            else {
                payload['GA_device__c'] = getCookie('gaconnector_device');
            }

            if(window.localStorage.getItem('gaconnector_fc_campaign') !== '' ){
                payload['GA_fc_campaign__c'] = window.localStorage.getItem('gaconnector_fc_campaign');
            }
            else {
                payload['GA_fc_campaign__c'] = getCookie('gaconnector_fc_campaign');
            }

            if(window.localStorage.getItem('gaconnector_fc_channel') !== '' ){
                payload['GA_fc_channel__c'] = window.localStorage.getItem('gaconnector_fc_channel');
            }
            else {
                payload['GA_fc_channel__c'] = getCookie('gaconnector_fc_channel');
            }

            if(window.localStorage.getItem('gaconnector_fc_content') !== '' ){
                payload['GA_fc_content__c'] = window.localStorage.getItem('gaconnector_fc_content');
            }
            else {
                payload['GA_fc_content__c'] = getCookie('gaconnector_fc_content');
            }

            if(window.localStorage.getItem('gaconnector_fc_landing') !== '' ){
                payload['GA_fc_landing__c'] = window.localStorage.getItem('gaconnector_fc_landing');
            }
            else {
                payload['GA_fc_landing__c'] = getCookie('gaconnector_fc_landing');
            }

            if(window.localStorage.getItem('gaconnector_fc_medium') !== '' ){
                payload['GA_fc_medium__c'] = window.localStorage.getItem('gaconnector_fc_medium');
            }
            else {
                payload['GA_fc_medium__c'] = getCookie('gaconnector_fc_medium');
            }

            if(window.localStorage.getItem('gaconnector_fc_referrer') !== '' ){
                payload['GA_fc_referrer__c'] = window.localStorage.getItem('gaconnector_fc_referrer');
            }
            else {
                payload['GA_fc_referrer__c'] = getCookie('gaconnector_fc_referrer');
            }

            if(window.localStorage.getItem('gaconnector_fc_source') !== '' ){
                payload['GA_fc_source__c'] = window.localStorage.getItem('gaconnector_fc_source');
            }
            else {
                payload['GA_fc_source__c'] = getCookie('gaconnector_fc_source');
            }

            if(window.localStorage.getItem('gaconnector_fc_term') !== '' ){
                payload['GA_fc_term__c'] = window.localStorage.getItem('gaconnector_fc_term');
            }
            else {
                payload['GA_fc_term__c'] = getCookie('gaconnector_fc_term');
            }

            if(window.localStorage.getItem('gaconnector_GA_Client_ID') !== '' ){
                payload['GA_Client_ID__c'] = window.localStorage.getItem('gaconnector_GA_Client_ID');
            }
            else {
                payload['GA_Client_ID__c'] = getCookie('gaconnector_GA_Client_ID');
            }

            if(window.localStorage.getItem('gaconnector_gclid') !== '' ){
                payload['GA_Galid__c'] = window.localStorage.getItem('gaconnector_gclid');
            }
            else {
                payload['GA_Galid__c'] = getCookie('gaconnector_gclid');
            }

            if(window.localStorage.getItem('gaconnector_ip_address') !== '' ){
                payload['GA_ip_address__c'] = window.localStorage.getItem('gaconnector_ip_address');
            }
            else {
                payload['GA_ip_address__c'] = getCookie('gaconnector_ip_address');
            }

            if(window.localStorage.getItem('gaconnector_lc_campaign') !== '' ){
                payload['GA_lc_campaign__c'] = window.localStorage.getItem('gaconnector_lc_campaign');
            }
            else {
                payload['GA_lc_campaign__c'] = getCookie('gaconnector_lc_campaign');
            }

            if(window.localStorage.getItem('gaconnector_lc_channel') !== '' ){
                payload['GA_lc_channel__c'] = window.localStorage.getItem('gaconnector_lc_channel');
            }
            else {
                payload['GA_lc_channel__c'] = getCookie('gaconnector_lc_channel');
            }

            if(window.localStorage.getItem('gaconnector_lc_content') !== '' ){
                payload['GA_lc_content__c'] = window.localStorage.getItem('gaconnector_lc_content');
            }
            else {
                payload['GA_lc_content__c'] = getCookie('gaconnector_lc_content');
            }

            if(window.localStorage.getItem('gaconnector_lc_landing') !== '' ){
                payload['GA_lc_landing__c'] = window.localStorage.getItem('gaconnector_lc_landing');
            }
            else {
                payload['GA_lc_landing__c'] = getCookie('gaconnector_lc_landing');
            }

            if(window.localStorage.getItem('gaconnector_lc_medium') !== '' ){
                payload['GA_lc_medium__c'] = window.localStorage.getItem('gaconnector_lc_medium');
            }
            else {
                payload['GA_lc_medium__c'] = getCookie('gaconnector_lc_medium');
            }

            if(window.localStorage.getItem('gaconnector_lc_referrer') !== '' ){
                payload['GA_lc_referrer__c'] = window.localStorage.getItem('gaconnector_lc_referrer');
            }
            else {
                payload['GA_lc_referrer__c'] = getCookie('gaconnector_lc_referrer');
            }

            if(window.localStorage.getItem('gaconnector_lc_source') !== '' ){
                payload['GA_lc_source__c'] = window.localStorage.getItem('gaconnector_lc_source');
            }
            else {
                payload['GA_lc_source__c'] = getCookie('gaconnector_lc_source');
            }

            if(window.localStorage.getItem('gaconnector_lc_term') !== '' ){
                payload['GA_lc_term__c'] = window.localStorage.getItem('gaconnector_lc_term');
            }
            else {
                payload['GA_lc_term__c'] = getCookie('gaconnector_lc_term');
            }

            if(window.localStorage.getItem('gaconnector_latitude') !== '' ){
                payload['GA_latitude__c'] = window.localStorage.getItem('gaconnector_latitude');
            }
            else {
                payload['GA_latitude__c'] = getCookie('gaconnector_latitude');
            }

            if(window.localStorage.getItem('gaconnector_longitude') !== '' ){
                payload['GA_longitude__c'] = window.localStorage.getItem('gaconnector_longitude');
            }
            else {
                payload['GA_longitude__c'] = getCookie('gaconnector_longitude');
            }

            if(window.localStorage.getItem('gaconnector_page_visits') !== '' ){
                payload['GA_page_visits__c'] = window.localStorage.getItem('gaconnector_page_visits');
            }
            else {
                payload['GA_page_visits__c'] = getCookie('gaconnector_page_visits');
            }

            if(window.localStorage.getItem('gaconnector_OS') !== '' ){
                payload['GA_OS__c'] = window.localStorage.getItem('gaconnector_OS');
            }
            else {
                payload['GA_OS__c'] = getCookie('gaconnector_OS');
            }

            if(window.localStorage.getItem('gaconnector_pages_visited_list') !== '' ){
                payload['GA_pages_visited_list__c'] = window.localStorage.getItem('gaconnector_pages_visited_list');
            }
            else {
                payload['GA_pages_visited_list__c'] = getCookie('gaconnector_pages_visited_list');
            }

            if(window.localStorage.getItem('gaconnector_region') !== '' ){
                payload['GA_region__c'] = window.localStorage.getItem('gaconnector_region');
            }
            else {
                payload['GA_region__c'] = getCookie('gaconnector_region');
            }

            if(window.localStorage.getItem('gaconnector_time_passed') !== '' ){
                payload['GA_time_passed__c'] = window.localStorage.getItem('gaconnector_time_passed');
            }
            else {
                payload['GA_time_passed__c'] = getCookie('gaconnector_time_passed');
            }

            if(window.localStorage.getItem('gaconnector_time_zone') !== '' ){
                payload['GA_time_zone__c'] = window.localStorage.getItem('gaconnector_time_zone');
            }
            else {
                payload['GA_time_zone__c'] = getCookie('gaconnector_time_zone');
            }
        }

        if (
            formTitle.value === 'SupportForm' &&
            Object.hasOwn(payload, 'WebRequestType__c') &&
            payload.WebRequestType__c !== null
        ) {
            formTopic.value = payload.WebRequestType__c; // Support Form category
        } else if (
            (formTitle.value === 'ContactForm' || formTitle.value === 'EmailForm') &&
            Object.hasOwn(payload, 'requestType') &&
            payload.requestType !== null
        ) {
            formTopic.value = payload.requestType; // Contact Form cards category
        } else if (
            formTitle.value === 'CampaignLandingPageForm' &&
            document.title !== undefined &&
            document.title !== null &&
            document.title.length > 0
        ) {
            formTopic.value = formTitle.value + document.title; // CampaignLandingPageForm + Document Title
        } else {
            formTopic.value = formTitle.value;
        }

        if (trackingTitle.value) {
            formTitle.value = trackingTitle.value;
        }

        window.dataLayer.push({
            event: 'form',
            'form-name': unref(formTitle),
            'form-topic': unref(formTopic),
        });
    };

    const generateAmsOsramPayload = payload => {
        const savedData = [];
        const realPayload = [];

        if (
            props.formTitle !== 'CampaignLandingPageForm' &&
            props.formTitle !== 'ContactForm' &&
            props.formTitle !== 'EmailForm' &&
            Object.hasOwn(payload, 'WebSalutation__c')
        ) {
            delete payload['WebSalutation__c'];
        }

        if (Object.hasOwn(payload, 'PrivacyPolicy__c')) {
            delete payload['PrivacyPolicy__c'];
        }

        if (Object.hasOwn(payload, 'locationTypes')) {
            delete payload['locationTypes'];
        }
        if (Object.hasOwn(payload, 'systems')) {
            delete payload['systems'];
        }

        if (Object.hasOwn(payload, 'Subject')) {
            payload['Subject'] = `${payload['Subject']}|${payload['SuppliedCompany']}|${payload['WebCountry__c']}||`;
        }

        if (Object.hasOwn(payload, 'PreferredDistributor__c') && payload['PreferredDistributor__c'] === '--None--') {
            payload['PreferredDistributor__c'] = '';
        }
        if (props.formTitle === 'QuestionnaireForm' && Object.hasOwn(payload, 'Type')) {
            if (payload['CustomExportTechSubCategory__c'] != '') {
                payload['TechSubCategory__c'] = payload['CustomExportTechSubCategory__c'];
            }
            else if (payload['ProductRelatedTechSubCategory__c'] != '') {
                payload['TechSubCategory__c'] = payload['ProductRelatedTechSubCategory__c'];
            }
            else if (payload['ProductionRelatedTechSubCategory__c'] != '') {
                payload['TechSubCategory__c'] = payload['ProductionRelatedTechSubCategory__c'];
            }
            else if (payload['QMTechSubCategory__c'] != ''){
                payload['TechSubCategory__c'] = payload['QMTechSubCategory__c'];
            }
            else if (payload['EHSTechSubCategory__c'] != '') {
                payload['TechSubCategory__c'] = payload['EHSTechSubCategory__c'];
            }
            else if (payload['AffairsTechSubCategory__c'] != '') {
                payload['TechSubCategory__c'] = payload['AffairsTechSubCategory__c'];
            }
            else if (payload['SupplierTechSubCategory__c'] != '') {
                payload['TechSubCategory__c'] = payload['SupplierTechSubCategory__c'];
            }
            else if (payload['SustainTechSubCategory__c'] != '') {
                payload['TechSubCategory__c'] = payload['SustainTechSubCategory__c'];
            }

            delete payload['SustainTechSubCategory__c'];
            delete payload['SupplierTechSubCategory__c'];
            delete payload['AffairsTechSubCategory__c'];
            delete payload['EHSTechSubCategory__c'];
            delete payload['QMTechSubCategory__c'];
            delete payload['ProductionRelatedTechSubCategory__c'];
            delete payload['ProductRelatedTechSubCategory__c'];
            delete payload['CustomExportTechSubCategory__c'];
        }


        if (props.formTitle === 'SupportForm' && Object.hasOwn(payload, 'Description')) {
            if (Object.hasOwn(payload, 'DocumentType__c')) {
                if (payload.DocumentType__c && payload.DocumentType__c.length > 0) {
                    payload['Description'] = `${payload['Description']}|${payload['DocumentType__c']}`;
                    savedData['DocumentType__c'] = payload['DocumentType__c'];
                }
                delete payload['DocumentType__c'];
            }

            if (Object.hasOwn(payload, 'DocumentVersion__c')) {
                if (payload.DocumentVersion__c && payload.DocumentVersion__c.length > 0) {
                    payload['Description'] = `${payload['Description']}|${payload['DocumentVersion__c']}`;
                    savedData['DocumentVersion__c'] = payload['DocumentVersion__c'];
                }
                delete payload['DocumentVersion__c'];
            }

            if (Object.hasOwn(payload, 'DocumentNumber__c')) {
                if (payload.DocumentNumber__c && payload.DocumentNumber__c.length > 0) {
                    payload['Description'] = `${payload['Description']}|${payload['DocumentNumber__c']}`;
                    savedData['DocumentNumber__c'] = payload['DocumentNumber__c'];
                }
                delete payload['DocumentNumber__c'];
            }

            if (Object.hasOwn(payload, 'DocumentTitle__c')) {
                if (payload.DocumentTitle__c && payload.DocumentTitle__c.length > 0) {
                    payload['Description'] = payload['Description'] + '|' + payload['DocumentTitle__c'];
                    savedData['DocumentTitle__c'] = payload['DocumentTitle__c'];
                }
                delete payload['DocumentTitle__c'];
            }

            if (Object.hasOwn(payload, 'PartNumber__c')) {
                if (payload.PartNumber__c && payload.PartNumber__c.length > 0) {
                    payload['Description'] = `${payload['Description']}|${payload['PartNumber__c']}`;
                    savedData['PartNumber__c'] = payload['PartNumber__c'];
                }
                delete payload['PartNumber__c'];
            }

            if (Object.hasOwn(payload, 'ProductArea__c')) {
                if (payload.ProductArea__c && payload.ProductArea__c.length > 0) {
                    payload['Description'] = `${payload['Description']}|${payload['ProductArea__c']}`;
                    savedData['ProductArea__c'] = payload['ProductArea__c'];

                    if (osramTypes.includes(payload['ProductArea__c'])) {
                        payload['Legacy_OS_ams__c'] = 'OS';
                    } else if (amsTypes.includes(payload['ProductArea__c'])) {
                        payload['Legacy_OS_ams__c'] = 'ams';
                    } else if (payload.Legacy_OS_ams__c !== null) {
                        delete payload['Legacy_OS_ams__c'];
                    }
                }
                delete payload['ProductArea__c'];
            }

            if (Object.hasOwn(payload, 'ledTypes__c')) {
                if (payload.ledTypes__c && payload.ledTypes__c.length > 0) {
                    payload['Description'] = `${payload['Description']}|${payload['ledTypes__c']}`;
                    savedData['ledTypes__c'] = payload['ledTypes__c'];
                }
                delete payload['ledTypes__c'];
            }

            if (Object.hasOwn(payload, 'laserType__c')) {
                if (payload.laserType__c && payload.laserType__c.length > 0) {
                    payload['Description'] = `${payload['Description']}|${payload['laserType__c']}`;
                    savedData['laserType__c'] = payload['laserType__c'];
                }
                delete payload['laserType__c'];
            }

            if (Object.hasOwn(payload, 'photodetectorsType__c')) {
                if (payload.photodetectorsType__c && payload.photodetectorsType__c.length > 0) {
                    payload['Description'] = `${payload['Description']}|${payload['photodetectorsType__c']}`;
                    savedData['photodetectorsType__c'] = payload['photodetectorsType__c'];
                }
                delete payload['photodetectorsType__c'];
            }

            if (Object.hasOwn(payload, 'sensorsType__c')) {
                if (payload.sensorsType__c && payload.sensorsType__c.length > 0) {
                    payload['Description'] = `${payload['Description']}|${payload['sensorsType__c']}`;
                    savedData['sensorsType__c'] = payload['sensorsType__c'];
                }
                delete payload['sensorsType__c'];
            }

            if (Object.hasOwn(payload, 'interfacesType__c')) {
                if (payload.interfacesType__c !== null && payload.interfacesType__c.length > 0) {
                    payload['Description'] = `${payload['Description']}|${payload['interfacesType__c']}`;
                    savedData['interfacesType__c'] = payload['interfacesType__c'];
                }
                delete payload['interfacesType__c'];
            }
        }

        if (Object.hasOwn(payload, 'requestType')) {
            let requestedValue = payload.requestType.charAt(0).toUpperCase() + payload.requestType.slice(1);
            payload['requestedType'] = `${requestedValue}Email`;
            delete payload['requestType'];
        }

        for (const key in payload) {
            if (typeof payload[key] === 'boolean') {
                payload[key] = payload[key].toString();
            }
            if (payload[key] === null) {
                payload[key] = '';
            }
        }

        return {
            payload,
            savedData,
        };
    };

    return {
        osramTypes,
        amsTypes,
        handleDataLayerFormTracking,
        generateAmsOsramPayload,
    };


};

    function getCookie(cname) {
        let name = cname + '=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
